export default __webpack_public_path__ + "static/lego-89c03d7f25200128bc09269bde39d2b1.gif";